import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { SparkLineChart } from '@mui/x-charts';
import { Button } from '../Button';

export const LatencyRow = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const LatencySkeleton = styled(Skeleton)`
  width: 100%;
  height: 50;
  margin-bottom: 10px;
`;

export const EditLatencyRow = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const NoAddress = styled(Stack)`
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
`;

export const AddAddressButton = styled(Button)`
  height: 30px;
  margin-right: 20px;
  margin-left: auto;
`;

export const LineChart = styled(SparkLineChart)`
  width: 100px;
  height: 30px;

  & .MuiAreaElement-root {
    fill-opacity: 0.3;
  }
`;
